export enum GiftCardEventType {
  Unavailable,
  BalanceSuccess,
  BalanceError,
  RevertTransactionCompleted,
  RevertTransactionFailed,
}
